import { defineStore } from 'pinia';

export const useRequestsExtractStore = defineStore('requests', {
  state: () => {
    return {
      requestId: '',
      response: {} as any,
      extracts: [],
      cloneOldTextAreaValue: '',
      cloneOldTextAreaValueRefusal: '',
    };
  },

  actions: {
    setResponse(res: any) {
      this.response = res;
      this.requestId = res?.object?.dimensions?.dim_order_id;

      const found_extracts = res.found_extracts.map((val, key) => {
        val.id = key + 1;
        return val;
      });

      this.sendExtract(found_extracts);
    },
    sendExtract(data: any) {
      this.extracts = data;
    },
    setExtract(data: object) {
      Object.assign(this.extracts, data);
    },
    deleteExtract(id: number | string) {
      this.extracts = this.extracts.filter(
        (val: { id: number }) => val.id !== id
      );
    },
  },

  getters: {
    getExtracts: state => state.extracts,
  },
});
